import React from "react";
import {Form} from "semantic-ui-react";

import CustomModal from "../CustomModal";
import Snackbar from "../Snackbar";

class AddAssetsFolder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payload: {
        name: '',
      },
      snackbar: {
        open: false,
        message: '',
        success: false,
        error: false
      }
    }
  }

  handleState = (e) => {
    let {name, value} = e.target;
    let {payload} = this.state;
    this.setState({
      payload: {
        ...payload,
        [name]: value
      }
    });
  };

  resetSnackbar = () => {
    this.setState({
      snackbar: {
        open: false,
        message: '',
        success: false,
        error: false
      }
    })
  }

  onSubmit = () => {
    const {addFolder, parent, onClose, userID} = this.props;
    const {payload} = this.state;
    addFolder({...payload, parent, user_id: userID}).then(() => {
      this.setState({
        payload: {
          name: '',
        },
        snackbar: {
          open: true,
          message: 'Folder Added',
          success: true,
          error: false
        }
      });
      onClose();
    }).catch((error) => {
        debugger
      this.setState({
        payload: {
          name: '',
        },
        snackbar: {
          open: true,
          message: error.data && error.data.message,
          success: false,
          error: true
        }
      });
      onClose();
    });
  }
  render() {
    const {payload: {name}, snackbar} = this.state;
    const {open, onClose, folderLoading} = this.props;
    return <>
      <CustomModal
        open={open}
        onClose={onClose}
        footer={true}
        title='Add Folder'
        onSubmit={this.onSubmit}
        submitLoader={folderLoading}
      >
        <Form>
          <Form.Field>
            <label>Name</label>
            <Form.Input
              fluid
              id="folder-name"
              value={name}
              onChange={this.handleState}
              name="name"
              placeholder="Folder Name"
            />
          </Form.Field>
        </Form>
      </CustomModal>
      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        error={snackbar.error}
        success={snackbar.success}
        onClose={this.resetSnackbar}
      />
    </>
  }
}

export default AddAssetsFolder;
